import React, { ReactElement } from 'react';
import Image from '../image/image.component';
import useStylesListItemImage from './list-item-image.styles';

const ListItemImage: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSmall,
    isCentered,
    text,
    link,
  } = props;

  const { classes } = useStylesListItemImage();

  return (
    <Image
      isSquare
      isSmall={isSmall}
      isCentered={isCentered}
      text={text}
      link={link}
      className={classes.listItemImage}
    />
  );
});

export default ListItemImage;
